// Author YuJiaBei
// Date 2021-12-15 15:12:09

import * as model from "@/model/em/repair/RepairPlanModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.RepairPlan(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_REPAIR_URL,
        callbackApi: process.env.VUE_APP_EM_REPAIR_URL + '/repairPlan/workflow/complete-feedback',
        processDefinitionKey: "em_repair_plan",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
